import Login from 'views/auth-views/authentication/login'

import PlayPage from 'views/public-views/play'
import ResultPage from 'views/public-views/result'
import PublicGameLobby from 'views/public-views/game-lobby'
import OfflinePreparePage from 'views/public-views/offline-prepare'

import DashboardPage from 'views/app-views/roulette/dashboard'
import ClientsPage from 'views/app-views/roulette/clients'
import ClientUsersPage from 'views/app-views/roulette/client-users'
import EventsPage from 'views/app-views/roulette/events'
import GamesPage from 'views/app-views/roulette/games'
import PrizesPage from 'views/app-views/roulette/prizes'
import InventoryPage from 'views/app-views/roulette/inventory'
import DailyLimitsPage from 'views/app-views/roulette/daily-limits'
import SpinsPage from 'views/app-views/roulette/spins'
import ReportsPage from 'views/app-views/roulette/reports'
import SettingsPage from 'views/app-views/roulette/settings'

import MemorySettingsPage from 'views/app-views/memory/settings'
import BalloonSettingsPage from 'views/app-views/balloon/settings'
import GameLobbySettingsPage from 'views/app-views/game-lobby/settings'
import QuizSettingsPage from 'views/app-views/quiz/settings'
import QuizAppearancePage from 'views/app-views/quiz/appearance'

import LeadsPage from 'views/app-views/leads'
import ProfilePage from 'views/app-views/profile'

import LeadFormsPage from 'views/app-views/lead-forms'
import LeadFormEditPage from 'views/app-views/lead-forms/form'
import GameRegistrationPage from 'views/public-views/game-registration'
import QrReaderPage from 'views/public-views/qr-reader'
import RiverRaceSettingsPage from 'views/app-views/river-race/settings'

export const protectedRoutes = [
  // ======================================================
  // DASHBOARD
  // ======================================================

  {
    key: 'dashboard',
    path: '/app/dashboard',
    component: DashboardPage,
    meta: {
      header: 'Dashboard',
      layout: 'main',
    },
  },

  // Compatibilidade com URL antiga
  {
    key: 'roulette-dashboard',
    path: '/app/roulette/dashboard',
    component: DashboardPage,
    meta: {
      header: 'Dashboard',
      layout: 'main',
    },
  },

  // ======================================================
  // PERFIL
  // ======================================================

  {
    key: 'profile',
    path: '/app/profile',
    component: ProfilePage,
    meta: {
      header: 'Meu Perfil',
      layout: 'main',
    },
  },

  // ======================================================
  // CLIENTES / EMPRESA
  // ======================================================

  {
    key: 'clients',
    path: '/app/clients',
    component: ClientsPage,
    meta: {
      header: 'Clientes',
      layout: 'main',
    },
  },

  // Compatibilidade
  {
    key: 'roulette-clients',
    path: '/app/roulette/clients',
    component: ClientsPage,
    meta: {
      header: 'Clientes',
      layout: 'main',
    },
  },

  {
    key: 'my-company',
    path: '/app/my-company',
    component: ClientsPage,
    meta: {
      header: 'Minha Empresa',
      layout: 'main',
    },
  },

  // ======================================================
  // USUÁRIOS
  // ======================================================

  {
    key: 'client-users',
    path: '/app/users',
    component: ClientUsersPage,
    meta: {
      header: 'Usuários',
      layout: 'main',
    },
  },

  // Compatibilidade
  {
    key: 'roulette-client-users',
    path: '/app/roulette/client-users',
    component: ClientUsersPage,
    meta: {
      header: 'Usuários',
      layout: 'main',
    },
  },

  // ======================================================
  // FORMULÁRIOS
  // ======================================================

  {
    key: 'lead-forms',
    path: '/app/lead-forms',
    component: LeadFormsPage,
    meta: {
      header: 'Formulários de Captação',
      layout: 'main',
    },
  },

  {
    key: 'lead-form-edit',
    path: '/app/lead-forms/:id',
    component: LeadFormEditPage,
    meta: {
      header: 'Editar Formulário',
      layout: 'main',
    },
  },

  // ======================================================
  // LEADS
  // ======================================================

  {
    key: 'leads',
    path: '/app/leads',
    component: LeadsPage,
    meta: {
      header: 'Leads',
      layout: 'main',
    },
  },

  // ======================================================
  // EVENTOS
  // ======================================================

  {
    key: 'events',
    path: '/app/events',
    component: EventsPage,
    meta: {
      header: 'Eventos',
      layout: 'main',
    },
  },

  // Compatibilidade
  {
    key: 'roulette-events',
    path: '/app/roulette/events',
    component: EventsPage,
    meta: {
      header: 'Eventos',
      layout: 'main',
    },
  },

  // ======================================================
  // JOGOS
  // ======================================================

  {
    key: 'games',
    path: '/app/games',
    component: GamesPage,
    meta: {
      header: 'Jogos',
      layout: 'main',
    },
  },

  // Compatibilidade
  {
    key: 'roulette-games',
    path: '/app/roulette/games',
    component: GamesPage,
    meta: {
      header: 'Jogos',
      layout: 'main',
    },
  },

  // ======================================================
  // PÁGINA INICIAL DOS JOGOS
  // ======================================================

  {
    key: 'game-lobby-settings',
    path: '/app/game-lobby/settings',
    component: GameLobbySettingsPage,
    meta: {
      header: 'Página Inicial dos Jogos',
      layout: 'main',
    },
  },

  // ======================================================
  // JOGO DA MEMÓRIA
  //
  // Rota propositalmente escondida do menu.
  // Será acessada através da página Jogos.
  // ======================================================

  {
    key: 'memory-settings',
    path: '/app/memory/settings',
    component: MemorySettingsPage,
    meta: {
      header: 'Jogo da Memória',
      layout: 'main',
    },
  },

  {
    key: 'quiz-settings',
    path: '/app/quiz/settings',
    component: QuizSettingsPage,
    meta: {
      header: 'Quiz Interativo',
      layout: 'main',
    },
  },

    {
    key: 'quiz-appearance',
    path: '/app/quiz/appearance',
    component: QuizAppearancePage,
    meta: {
      header: 'Personalização do Quiz',
      layout: 'main',
    },
  },

  // ======================================================
  // RIVER RACE
  //
  // Jogo externo em Unity.
  // Acessado através da página Jogos.
  // ======================================================

  {
    key: 'river-race-settings',
    path: '/app/river-race/settings',
    component: RiverRaceSettingsPage,
    meta: {
      header: 'River Race',
      layout: 'main',
    },
  },

  // ======================================================
  // ESTOURO DE BALÕES
  //
  // Rota propositalmente escondida do menu.
  // Será acessada através da página Jogos.
  // ======================================================

  {
    key: 'balloon-settings',
    path: '/app/balloon/settings',
    component: BalloonSettingsPage,
    meta: {
      header: 'Estouro de Balões',
      layout: 'main',
    },
  },

  // ======================================================
  // BRINDES
  // ======================================================

  {
    key: 'prizes',
    path: '/app/prizes',
    component: PrizesPage,
    meta: {
      header: 'Brindes',
      layout: 'main',
    },
  },

  // Compatibilidade
  {
    key: 'roulette-prizes',
    path: '/app/roulette/prizes',
    component: PrizesPage,
    meta: {
      header: 'Brindes',
      layout: 'main',
    },
  },

  // ======================================================
  // ESTOQUE
  // ======================================================

  {
    key: 'inventory',
    path: '/app/inventory',
    component: InventoryPage,
    meta: {
      header: 'Estoque de Brindes',
      layout: 'main',
    },
  },

  // Compatibilidade
  {
    key: 'roulette-inventory',
    path: '/app/roulette/inventory',
    component: InventoryPage,
    meta: {
      header: 'Estoque de Brindes',
      layout: 'main',
    },
  },

  // ======================================================
  // LIMITES DIÁRIOS
  // ======================================================

  {
    key: 'daily-limits',
    path: '/app/daily-limits',
    component: DailyLimitsPage,
    meta: {
      header: 'Limites Diários',
      layout: 'main',
    },
  },

  // Compatibilidade
  {
    key: 'roulette-daily-limits',
    path: '/app/roulette/daily-limits',
    component: DailyLimitsPage,
    meta: {
      header: 'Limites Diários',
      layout: 'main',
    },
  },

  // ======================================================
  // JOGADAS
  // ======================================================

  {
    key: 'spins',
    path: '/app/spins',
    component: SpinsPage,
    meta: {
      header: 'Jogadas',
      layout: 'main',
    },
  },

  // Compatibilidade
  {
    key: 'roulette-spins',
    path: '/app/roulette/spins',
    component: SpinsPage,
    meta: {
      header: 'Jogadas',
      layout: 'main',
    },
  },

  // ======================================================
  // RELATÓRIOS
  // ======================================================

  {
    key: 'reports',
    path: '/app/reports',
    component: ReportsPage,
    meta: {
      header: 'Relatórios',
      layout: 'main',
    },
  },

  // Compatibilidade
  {
    key: 'roulette-reports',
    path: '/app/roulette/reports',
    component: ReportsPage,
    meta: {
      header: 'Relatórios',
      layout: 'main',
    },
  },

  // ======================================================
  // CONFIGURAÇÕES
  // ======================================================

  {
    key: 'settings',
    path: '/app/settings',
    component: SettingsPage,
    meta: {
      header: 'Configurações',
      layout: 'main',
    },
  },

  // Compatibilidade
  {
    key: 'roulette-settings',
    path: '/app/roulette/settings',
    component: SettingsPage,
    meta: {
      header: 'Configurações',
      layout: 'main',
    },
  },
]

export const publicRoutes = [
  // ======================================================
  // LOGIN
  // ======================================================

  {
    key: 'login',
    path: '/auth/login',
    component: Login,
  },

  // ======================================================
  // PREPARAÇÃO OFFLINE
  // ======================================================

  {
    key: 'offline-prepare',
    path: '/offline-prepare/:slug',
    component: OfflinePreparePage,
    meta: {
      blankLayout: true,
    },
  },

  //======================================================
  // PÁGINA INICIAL DOS JOGOS
  // ======================================================

  {
    key: 'game-lobby',
    path: '/lobby/:eventSlug',
    component: PublicGameLobby,
    meta: {
      blankLayout: true,
    },
  },

  // ======================================================
  // LEITOR DE QR CODE - RIVER RACE
  // ======================================================

  {
    key: 'qr-reader',
    path: '/qr-reader',
    component: QrReaderPage,
    meta: {
      blankLayout: true,
    },
  },

  // ======================================================
  // CADASTRO DE PARTICIPANTE - UNITY / RIVER RACE
  // ======================================================

  {
    key: 'game-registration',
    path: '/join/:publicToken',
    component: GameRegistrationPage,
    meta: {
      blankLayout: true,
    },
  },

  // ======================================================
  // EXECUÇÃO DOS JOGOS
  // ======================================================

  {
    key: 'play-game',
    path: '/play/:slug',
    component: PlayPage,
    meta: {
      blankLayout: true,
    },
  },


  // ======================================================
  // RESULTADO DA ROLETA
  //
  // Mantemos a URL antiga para compatibilidade.
  //
  // Exemplo:
  // /p/6fe2776b-1b47-47db-8d5f-00186442acf7
  // ======================================================

  {
    key: 'roulette-result',
    path: '/p/:spinId',
    component: ResultPage,
    meta: {
      blankLayout: true,
    },
  },

  // ======================================================
  // RESULTADO GENÉRICO DOS JOGOS
  //
  // Exemplos:
  //
  // /r/memory/:matchId
  // /r/quiz/:matchId
  // /r/roulette/:spinId   (futuramente)
  // ======================================================

  {
    key: 'game-result',
    path: '/r/:type/:id',
    component: ResultPage,
    meta: {
      blankLayout: true,
    },
  },
]